import React from 'react';
import strawberryFestival from '../assets/images/strawberry-festival.png';
import './PrintingPage.scss';

class PrintingPage extends React.Component {
  render() {
    return (
      <div className="printing">
        <section className="printing-hero">
          <div className="container">
            <h1>As seen at the Strawberry Festival</h1>
            <img
              src={strawberryFestival}
              alt="Hookshot at the Strawberry Festival"
              className="printing-hero-image"
            />
          </div>
        </section>

        <section className="container">
          <div className="printing-body">
            <h2>3D Printing at Hookshot</h2>
            <p>
              In addition to our software, we design and sell custom 3D printed
              goods. Every piece is printed in-house and finished by hand.
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default PrintingPage;
